import ClearIcon from "@mui/icons-material/Clear"
import { Chip } from "@mui/material"
import { useTranslation } from "react-i18next"

import { usePartnerCode } from "@/features/PartnerCode"

export const PartnerCodeDisplay = () => {
  const { t } = useTranslation()
  const { partnerCode, clearPartnerCode } = usePartnerCode()

  if (!partnerCode) {
    return null
  }

  return (
    <Chip
      label={`${t("partnerCode")}: ${partnerCode}`}
      color="secondary"
      onDelete={clearPartnerCode}
      deleteIcon={<ClearIcon />}
    />
  )
}
